import { colors } from '@smartsheet/lodestar-core';
import { TrashIcon } from '@smartsheet/lodestar-icons';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { GraphNodeTypes } from '../../../../services/ducks/designerDuck/designerDuck';
import { removeNodeFromGraph } from '../../../../services/ducks/workflowDuck/workflowDuck';
import { IconButton } from '../../../common/IconButton';

export const RemoveNodeButton = ({
  node,
}: {
  node: {
    id: string;
    type: GraphNodeTypes;
  };
}) => {
  const dispatch = useDispatch();
  const { t: translate } = useTranslation();
  if (!node) return null;

  return (
    <IconButton
      appearance="borderless"
      size="medium"
      onClick={e => {
        e.stopPropagation();
        dispatch(removeNodeFromGraph(node));
      }}
      aria-label={translate(
        `designer:canvas.remove${GraphNodeTypes[node.type].toLowerCase()}`
      )}
    >
      <TrashIcon color={colors.neutralDark40} size="small" />
    </IconButton>
  );
};
